import { render, staticRenderFns } from "./GroupComponent.vue?vue&type=template&id=27faa6a4&"
import script from "./GroupComponent.vue?vue&type=script&lang=ts&"
export * from "./GroupComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports